import { render } from "./circular-progress.vue?vue&type=template&id=19bd38be&scoped=true&ts=true"
import script from "./circular-progress.ts?vue&type=script&lang=ts&external"
export * from "./circular-progress.ts?vue&type=script&lang=ts&external"

import "./circular-progress.less?vue&type=style&index=0&id=19bd38be&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bd38be"]])

export default __exports__
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCircularProgress});
